import React from 'react'

export type WrapperProps = {
  children: React.ReactNode
  noBorder?: boolean
}

const Wrapper: React.FC<WrapperProps> = ({ children, noBorder = false }) => (
  <div
    className={`container mx-auto min-h-content rounded-xl w-full ${
      noBorder ? '' : 'border border-gray-400'
    }`}
  >
    {children}
  </div>
)

export default Wrapper
